import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { months } from 'src/app/shared/model/months';
import { UserService } from 'src/app/shared/services/user.service';
import { UserConstant } from 'src/app/shared/constants/user-constant';
import { ReportService } from 'src/app/shared/services/report.service';
import { MatTableExporterDirective } from 'mat-table-exporter';
import { FormatterHelper } from 'src/app/shared/helper/formatter-helper';


@Component({
  selector: 'app-monitoring-stream',
  templateUrl: './monitoring-stream.component.html',
  styleUrls: ['./monitoring-stream.component.scss']
})
export class MonitoringStreamComponent implements OnInit {
    months = months
    years
    selectedMonth: Number
    selectedYear: Number
    startDate: any;
    endDate: any;
    startMonth = new FormControl(moment(new Date()).subtract(2, 'months'));
    endMonth = new FormControl(moment());
    minDate = moment(new Date()).subtract(3, 'year');
    maxDate = moment(new Date()); 
    @Output() sortChange = new EventEmitter<any>();
  
    orgId: any;
    org: any;    
    orgName: string;
    searchPipe
    allOrgList
    mmspList: any[] = []
    filteredMmspList: any[] = []
    mmspSearchPipe
    mspList: any[] = []
    filteredMspList: any[] = []
    mspSearchPipe
    orgList: any[] = []
    filteredOrgList: any[] = []
    readonly maxOrgOptions = 100
    currentRole: Number
    selectedOrgIds: any[] = []
    selectedMMsp: string
    selectedMsp: string
    selectAllOrg = false
    searchForm: FormGroup
  
    displayedReportColumns: string[] = ['mmsp', 'msp', 'org', 'name', 'mac', 'firmware', 'model', 'reportDate', 'overlay', 'glte']
    reportMonthlyDataSource: MatTableDataSource<any>
    @ViewChild(MatTableExporterDirective, { static: true }) exporter!: MatTableExporterDirective;
  constructor(private userService: UserService,
    private reportService: ReportService
  ) { 
    this.reportMonthlyDataSource = new MatTableDataSource<any>();
  }

  ngOnInit(): void {
    this.searchForm = new FormGroup({
      month: new FormControl(),
      year: new FormControl(),
      mmsp: new FormControl(),
      msp: new FormControl(),
      linked_orgs: new FormControl()
   });
   const currentMonth = Number(new Date().getMonth())
   this.selectedMonth = this.months[currentMonth].value
   const currentYear = Number(new Date().getFullYear())
   this.years = [currentYear, currentYear - 1]
   this.selectedYear = currentYear
   this.searchForm.controls.month.setValue(this.months[currentMonth].value)
   this.searchForm.controls.year.setValue(this.years[0])
   this.loadAllOrganization()
  }
  getDomainOrgs(domain) {
    let filteredOrg = [];    
    filteredOrg.push({ orgId: domain._id, name: domain.name, domain: domain.domain, role: domain.role, parentOrg: domain.parentOrganization })
  
    for (let i = 0; i < domain.subOrganizations.length; i++) {
      let org = domain.subOrganizations[i];
      filteredOrg = [...filteredOrg, ...this.getDomainOrgs(org)]
    }
    return filteredOrg;
  }

  
  loadData(){
    const orgIds = this.normalizeOrgIds(this.searchForm.controls.linked_orgs.value || this.selectedOrgIds);
    let request = {
      month: Number(this.selectedMonth),
      year: this.selectedYear,
      orgIds: orgIds,
      msp: this.selectedMsp ?? ""
    }
    this.reportService.getReportMonthly(this.selectedMMsp ?? this.orgId, request).subscribe(response=> {
       const data = response.data.map(x=>{
        const reportDate = x.report.length > 0 && x.report[0]?.reportDate ? new Date(x.report[0].reportDate) : null;
        return {
          mmsp: x.mmsp && x.mmsp!="" ?  x.mmsp : this.org[0]?.name,
          msp: x.msp,
          org: x.org,
          name: x.name ?? "",
          mac: x.mac,
          firmware: x.firmware,
          model: x.model,
          activatedAt: x.activatedAt,
          overlay: FormatterHelper.formatBytes(x.report[0]?.wg1 ?? 0),
          glte: FormatterHelper.formatBytes(x.report[0]?.glte ?? 0, 1000),
          reportDate: reportDate ? this.months[reportDate.getMonth()].name + " " + reportDate.getFullYear() : ""
        }
      })
      this.reportMonthlyDataSource.data = data
    })
    // console.log(request)
  }

  loadAllOrganization() {
      let user = JSON.parse(localStorage.getItem(UserConstant.USER));
      this.orgId = this.userService.normalizeOrganizationId(user.organization);
      this.orgName = user.organizationName;
      let obj = {
        id: this.orgId
      }
      this.currentRole = user.role 
      if(user.role!= 1 && user.role!=0){
        this.searchForm.controls.msp.setValue(this.orgId)
        this.selectedMsp = this.orgId
      }
      this.userService.getOrganizationUsers(obj).subscribe(results => {
            this.allOrgList = this.getDomainOrgs(results.data[0]);
            if(user.role == 0){
              this.setMmspList(this.allOrgList.filter(x=> x.role == 1))
            } else {
              this.setMspList(this.allOrgList.filter(x=> x.role == 2))
            }
            if (this.searchForm.controls.msp.value != "All" && this.searchForm.controls.msp.value != "" && user.role!= 1 && user.role!=0) {
              this.setOrgList([ {name: "All", orgId: "All"} ,...this.allOrgList.filter(x=> x.parentOrg == this.orgId && x.role == 3)])
            }
          })   
  }
  searchFocus(){
    this.filterOrgOptions(this.searchPipe);
  }

  onSelectMonth(e){
    this.selectedMonth = e.value
  }

  onSelectYear(e){
    this.selectedYear = e.value
  }

  onSelectMMSP(e){
    this.setMspList([])
    this.selectedMMsp = e.value
    this.selectedMsp = "";
    this.selectedOrgIds = [];
    this.searchForm.controls.msp.setValue("");
    this.searchForm.controls.linked_orgs.setValue([]);
    this.setOrgList([]);
    this.setMspList([ {name: "All", orgId: "All"}, ...this.allOrgList.filter(x=> x.parentOrg == e.value && x.role == 2)])
  }

  onSelectMSP(e){
    this.selectedMsp = e.value
    this.selectedOrgIds = [];
    this.searchForm.controls.linked_orgs.setValue([]);
    this.setOrgList([ {name: "All", orgId: "All"} ,...this.allOrgList.filter(x=> x.parentOrg == e.value && x.role == 3)])
  }

  onSelectOrgs(e){
    const selectedIds = this.normalizeOrgIds(e.value);
    const orgIds = this.getCurrentOrgIds();
    const hasAll = selectedIds.indexOf("All") > -1;

    if (hasAll && !this.selectAllOrg) {
      this.setSelectedOrgIds(["All", ...orgIds], true);
      return;
    }

    if (!hasAll && this.selectAllOrg) {
      this.setSelectedOrgIds([], false);
      return;
    }

    if (hasAll && selectedIds.length < orgIds.length + 1) {
      this.setSelectedOrgIds(selectedIds.filter(id => id !== "All"), false);
      return;
    }

    this.setSelectedOrgIds(selectedIds, hasAll);
   }

   setSelectedOrgIds(ids, selectAll) {
    this.selectedOrgIds = ids;
    this.selectAllOrg = selectAll;
    this.searchForm.controls.linked_orgs.setValue(ids, { emitEvent: false });
   }

   getCurrentOrgIds() {
    return (this.orgList || [])
      .filter(org => org.orgId && org.orgId !== "All")
      .map(org => org.orgId);
   }

   setMmspList(mmspList) {
    this.mmspList = this.prepareSearchableOrgList(mmspList);
    this.filterMmspOptions(this.mmspSearchPipe);
   }

   setMspList(mspList) {
    this.mspList = this.prepareSearchableOrgList(mspList);
    this.filterMspOptions(this.mspSearchPipe);
   }

   setOrgList(orgList) {
    this.orgList = this.prepareSearchableOrgList(orgList);
    this.filterOrgOptions(this.searchPipe);
   }

   prepareSearchableOrgList(orgList) {
    return (orgList || []).map(org => {
      return {
        ...org,
        searchName: (org.name || '').toLowerCase()
      };
    });
   }

   filterMmspOptions(searchText = '') {
    this.filteredMmspList = this.filterSearchableOrgList(this.mmspList, searchText);
   }

   filterMspOptions(searchText = '') {
    this.filteredMspList = this.filterSearchableOrgList(this.mspList, searchText);
   }

   filterOrgOptions(searchText = '') {
    const term = (searchText || '').toLowerCase().trim();
    const allOption = (this.orgList || []).filter(org => org.orgId === 'All');
    const orgOptions = (this.orgList || []).filter(org => {
      return org.orgId !== 'All' && (!term || org.searchName.indexOf(term) > -1);
    }).slice(0, this.maxOrgOptions);

    this.filteredOrgList = [...allOption, ...orgOptions];
   }

   filterSearchableOrgList(list, searchText = '') {
    const term = (searchText || '').toLowerCase().trim();
    return (list || []).filter(org => {
      return !term || org.searchName.indexOf(term) > -1;
    });
   }

   trackByOrgId(index, organization) {
    return organization.orgId;
   }

   normalizeOrgIds(value) {
    let orgIds = Array.isArray(value) ? value : (value ? [value] : []);
    orgIds = orgIds
      .map(id => this.userService.normalizeOrganizationId(id))
      .filter(id => id && id !== 'undefined');

    return orgIds;
   }
   exportToExcel() {
    this.exporter.exportTable('xlsx', { fileName: 'exported_table' });
  }
}
